import { render, staticRenderFns } from "./ModalSurfaceEdit.vue?vue&type=template&id=64d8f0d8&scoped=true"
import script from "./ModalSurfaceEdit.vue?vue&type=script&lang=js"
export * from "./ModalSurfaceEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalSurfaceEdit.vue?vue&type=style&index=0&id=64d8f0d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d8f0d8",
  null
  
)

export default component.exports